import { SIZE_MAP } from './constants.js';
import { text } from '@hubble/tokens/web';

const getInitials = name => {
  const n = name.split(' ');
  if (n.length < 2) {
    return n[0].charAt(0).toUpperCase();
  }
  const firstInitial = n[0].charAt(0).toUpperCase();
  const lastInitial = n[n.length - 1].charAt(0).toUpperCase();
  return firstInitial + lastInitial;
};
const getMaxFontSize = size => {
  const containerSize = parseInt(size);
  return containerSize > parseInt(SIZE_MAP.sm) ? text.typesets.body.sm.fontSize : `${containerSize * 0.5}px`;
};

export { getInitials, getMaxFontSize };
